export type EmployeeAutomation =
  | 'NONE'
  | 'SELECTED_EMP'
  | 'SELECTED_EMP_MANAGER'
  | 'SELECTED_EMP_HR_RESP'
  | 'NAMED_EMP'
  | 'LOGGED_IN_USER'
  | 'LOGGED_IN_USER_MANAGER'
  | 'LOGGED_IN_USER_HR_RESP';

export type CollaborationWorkList = {
  fCollaborationTemplateId: number;
  fCollaborationTemplateTitle: string;
  fCollaborationTemplateIsActive: boolean;
  fCollaborationTemplateDescription: string;
  fCollaborationTemplateTypeFK: string;
  fCollaborationTemplateCreatedTime: string; // Date
  fCollaborationTemplateCreatedUserFK: number;
  fCollaborationTemplateUpdatedTime: string; // Date
  fCollaborationTemplateUpdatedUserFK: number;
  fCollaborationTemplateIsUsed: boolean;
};

export type CollaborationWorkListTemplateTask = {
  fCollaborationTemplateTaskId: number;
  fCollaborationTemplateTaskSeq?: number;
  fCollaborationTemplateTaskTemplateFK: number;
  fCollaborationTemplateTaskTitle: string;
  fCollaborationTemplateTaskDescription: string;
  fCollaborationTemplateTaskTypeFK: string;
  fCollaborationTemplateTaskAutomnStartDay: number;
  fCollaborationTemplateTaskAutomnDueDay: number;
  fCollaborationTemplateTaskAutomnAssignee: EmployeeAutomation;
  fCollaborationTemplateTaskAutomnPertainingTo: string;
  fCollaborationTemplateTaskVisibleToPertTo: false;
  fCollaborationTemplateTaskCreatedTime: string; // Date
  fCollaborationTemplateTaskCreatedUserFK: number;
  fCollaborationTemplateTaskUpdatedTime: string; // Date
  fCollaborationTemplateTaskUpdatedUserFK: number;
  fCollaborationTemplateTaskLink: string;
  fCollaborationTemplateTaskAttachmentId: number;
  fCollaborationTemplateTaskAttachmentName: string;
  fCollaborationTemplateTaskAttachmentIsArchived: boolean;
};

export type CollaborationWorkListTemplate = CollaborationWorkList & {
  fCollaborationTemplateTasks: CollaborationWorkListTemplateTask[];
};

export enum EmployeeCollaborationTaskStatus {
  Completed = 'COMPLETED',
  Skipped = 'SKIPPED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Deleted = 'DELETED',
}

export type EmployeeCollaborationTask = {
  fTaskId: string;
  fTaskSeq?: number;
  taskCore: {
    fTaskType: string; // ENUM
    fTaskTitle: string;
    fTaskDescription: string;
    fTaskIsVisibleToPertainingTo: boolean;
    fTaskAssignorId: number;
    fTaskAssigneeId?: number;
    fTaskPertainingToId: number;
    fTaskTemplateId?: number;
    fTaskWorklistUid?: string;
    fTaskLink?: string;
  };
  taskState: {
    fTaskStatus: EmployeeCollaborationTaskStatus;
    fTaskStartDate: string; // Date
    fTaskDueDate?: string; // Date
  };
  taskAudit: {
    fTaskCreatedTime: string;
    fTaskUpdatedTime: string;
    fTaskUpdatedEmpId?: number;
  };
  fTaskAttachmentId: number;
  fTaskAttachmentName: string;
  fTaskAttachmentIsArchived?: boolean;
};

export enum EmployeeCollaborationWorklistStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Deleted = 'DELETED',
}

export type EmployeeCollaborationTaskList = {
  fEmpWorklistUid: string;
  fEmpWorklistEmployeeId: number;
  fEmpWorklistTemplateId: number;
  fEmpWorklistStartDate?: string; // Date
  fEmpWorklistDueDate: string; // Date
  fEmpWorklistStatus: EmployeeCollaborationWorklistStatus;
  fEmpWorklistLanguage?: string;
  fEmpWorklistIsLocked: boolean;
  fEmpWorklistTasks: EmployeeCollaborationTask[];
};
